module.exports = __webpack_public_path__ + "img/icon_tap_09.bf8c10e9.svg";